import { agoraBrasilia } from "../../../Funcoes/FormatBrasiliaDatetime";
import { formatarData } from "../../../Funcoes/FormatarData";

export function sqlToDatetimeLocal(value) {
    if (!value) return "";
    return String(value).replace(" ", "T").slice(0, 16);
}

export function agoraDatetimeLocal() {
    return sqlToDatetimeLocal(agoraBrasilia());
}

export const TIPO_TESTE_OPTIONS = [
    { value: "BAFOMETRO", label: "BAFÔMETRO" },
    { value: "TOXICOLOGICO", label: "TOXICOLÓGICO" },
];

export function formatTipoTeste(value) {
    if (!value) return "-";
    const opt = TIPO_TESTE_OPTIONS.find((o) => o.value === value);
    return opt?.label ?? String(value);
}

export function formatarDataHora(value) {
    if (!value) return "-";
    const s = String(value);
    const datePart = s.slice(0, 10);
    const timePart = s.length > 10 ? s.slice(11, 16) : "";
    try {
        const dataFmt = formatarData(datePart);
        return timePart ? `${dataFmt} ${timePart}` : dataFmt;
    } catch {
        return s;
    }
}
